import React, { Component } from 'react';

import ModalModule from '../modal';

import Settings from './Settings.component';

const { Modal, ModalContext, ModalButtonActionType } = ModalModule;

export default class SettingsModal extends Component {
	constructor(props) {
		super(props);

		this.state = {
			width: 990,
			height: 750,
		};
	}

	closeSettings = () => {
		const { modalId } = this.props;
		const { closeModal } = this.context;

		closeModal(modalId, ModalButtonActionType.Ok);
	};

	setModalSize = (newWidth, newHeight) => {
		this.setState({
			width: newWidth,
			height: newHeight,
		});
	};

	render() {
		const { modalId, activeTab } = this.props;
		const { width, height } = this.state;

		return (
			<Modal
				modalId={modalId}
				width={width}
				height={height}
				className="common-settings settings-modal"
				header="Settings"
				hideFooter
			>
				<Settings
					completionCallback={this.closeSettings}
					setModalSize={this.setModalSize}
					activeTab={activeTab} // parameter passed to the Settings module to directly open a specific tab
				/>
			</Modal>
		);
	}
}

SettingsModal.contextType = ModalContext;
